<template>
  <li ref="slide" class="discovery__item -small slide">
    <figure class="discovery__image" :style="{ backgroundImage: `url(${image})` }" />
    <h4 class="discovery__title">{{ title }}</h4>
    <ContentRaw :html="content" />
  </li>
</template>

<script>
import { ContentRaw } from '@/components/content'

export default {
  name: 'DiscoverySliderItem',
  components: { ContentRaw },
  props: {
    image: { type: String, default: null },
    title: { type: String, default: null },
    content: { type: String, default: null },
    link: { type: Object, default: null }
  },
  mounted() {
    this.$nextTick(() => {
      const { clientHeight = 0 } = this.$refs.slide || {}
      this.$emit('report-height', clientHeight)
    })
  }
}
</script>
